<div class="header">
    <h1 class="header__title">הודעות סמס אוטומטיות</h1>
    <button class="button button_with-icon button_size_small button_theme_main header__button" (click)="goAutomationMain()">
        שמור
        <i class="fa-solid fa-arrow-right"></i>
    </button>
    <button class="header__button_size_small" (click)="goAutomationMain()">
        <i class="fa-regular fa-arrow-right"></i>
    </button>
</div>

<!-- Loader -->

<div *ngIf="isLoaderVisible" class="loader"></div>

<div *ngIf="!isLoaderVisible" class="templates">
    <div class="template-group">
        <div class="template-group__icon-wrapper">
            <img class="template-group__icon" src="/assets/img/Automation/icon-reminder.png" />
        </div>

        <h2 class="template-group__title">שליחת תזכורות על התורים</h2>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('vizitReminder', 1)">
                <label class="switch-label template__switch">
                    שלח/י תזכורת סמס ללקוחות
                    <input class="switch" [(ngModel)]="receivedparameters.vizitReminder" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.vizitReminder" [isAnimated]="true">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_type_range template__range">
                    <span class="input-label">{{ receivedparameters.daysbefore }} ימים לפני הפגישה</span>
                    <div class="range">
                        <button class="range__button range__button_plus" (click)="timeValueIncrement('daysbefore', 7)">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                        <input
                            class="input"
                            [(ngModel)]="receivedparameters.daysbefore"
                            (focus)="onRangeFocus($event.target)"
                            (input)="onRangeChange('daysbefore', $event.target, 1, 7)"
                        />
                        <button class="range__button range__button_minus" (click)="timeValueDecrement('daysbefore', 1)">
                            <i class="fa-regular fa-minus"></i>
                        </button>
                    </div>
                </div>

                <div class="timepicker-wrapper template__timepicker">
                    <timepicker class="timepicker" [(ngModel)]="receivedparameters.hourSend" [showMeridian]="false"></timepicker>
                    <span class="timepicker-label">בשעה</span>
                </div>

                <div class="template__editor">
                    <h3 class="editor__title">נוסח ההודעה</h3>

                    <div class="editor__area">
                        <div class="editor__buttons">
                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="openEditor('bodyvizit', 1)"
                            >
                                עריכה
                                <i class="fa-regular fa-pen-line"></i>
                            </button>

                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="previewText('bodyvizit')"
                            >
                                תצוגה
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </div>

                        <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea template__textarea">
                            <textarea
                                class="input custom-scrollbar"
                                [(ngModel)]="receivedparameters.bodyvizit"
                                placeholder="הוסף הערות..."
                                readonly
                                disabled
                            ></textarea>

                            <span class="input-details">
                                {{ receivedparameters.bodyvizit?.length }} תווים
                                <span *ngIf="getSMSCount('bodyvizit') > 1"> , ישלח כהודעה אחת בעלות {{ getSMSCount("bodyvizit") }} סמסים </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="template__settings">
                    <label class="checkbox-label template__checkbox">
                        <span
                            class="template__tooltip"
                            tooltip="במידה והלקוח ילחץ על הלינק ויאשר הגעה יופיע לכם ביומן סימון מיוחד של V ירוק על התור (מומלץ)"
                            (click)="preventDefault($event)"
                        >
                            <i class="fa-regular fa-circle-info"></i>
                        </span>
                        הוסף לינק לאישור הגעה ע"י הלקוח בסיום ההודעה (מומלץ)
                        <input class="checkbox" [(ngModel)]="receivedparameters.isAddLink" type="checkbox" (change)="settingsCheckboxClick()" />
                        <span class="custom-checkbox"></span>
                    </label>

                    <button
                        class="button button_size_small button_with-icon button_theme_gray settings__button"
                        (click)="showAdminPanel()"
                        [hidden]="!receivedparameters.isAddLink"
                    >
                        הגדרות
                        <i class="fa-regular fa-gear"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="template-group">
        <div class="template-group__icon-wrapper">
            <img class="template-group__icon" src="/assets/img/Automation/icon-greeting.png" />
        </div>

        <h2 class="template-group__title">ברכות יום הולדת</h2>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('birthdayReminder', 2)">
                <label class="switch-label template__switch">
                    שלח/י ברכות יום הולדת ללקוחות
                    <input class="switch" [(ngModel)]="receivedparameters.birthdayReminder" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.birthdayReminder" isAnimated="true">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select template__select">
                    <span class="input-label">סוג השליחה</span>
                    <select class="input" [(ngModel)]="receivedparameters.birthdayMethod" (change)="onBirthdayMethodChange()">
                        <option *ngFor="let option of methodData" [value]="option.id">{{ option.name }}</option>
                    </select>
                </div>

                <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select template__select">
                    <span class="input-label">שלח ללקוחות שיש להם יום הולדת</span>
                    <select class="input" [(ngModel)]="receivedparameters.birthdayPeriodic" (change)="onBirthdayPeriodicChange()">
                        <option *ngFor="let option of timeData" [value]="option.id">{{ option.name }}</option>
                    </select>
                </div>

                <div
                    class="timepicker-wrapper template__timepicker"
                    [ngClass]="{ template__timepicker_collapsed: receivedparameters.birthdayMethod != 1 }"
                >
                    <timepicker class="timepicker" [(ngModel)]="receivedparameters.birthdayHourSend" [showMeridian]="false"></timepicker>
                    <span class="timepicker-label">בשעה</span>
                </div>

                <div class="template__editor">
                    <h3 class="editor__title">נוסח ההודעה</h3>

                    <div class="editor__area">
                        <div class="editor__buttons">
                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="openEditor('bodyBirthday', 2)"
                            >
                                עריכה
                                <i class="fa-regular fa-pen-line"></i>
                            </button>

                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="previewText('bodyBirthday')"
                            >
                                תצוגה
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </div>

                        <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea template__textarea">
                            <textarea
                                class="input custom-scrollbar"
                                [(ngModel)]="receivedparameters.bodyBirthday"
                                placeholder="הוסף הערות..."
                                readonly
                                disabled
                            ></textarea>

                            <span class="input-details">
                                {{ receivedparameters.bodyBirthday?.length }} תווים
                                <span *ngIf="getSMSCount('bodyBirthday') > 1"> , ישלח כהודעה אחת בעלות {{ getSMSCount("bodyBirthday") }} סמסים </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="template__note">
                    <span class="note__text">ע"פ חוק הספאם להודעה זו מצורף ללקוח/ה לינק להסרה</span>
                    <span class="template__tooltip" tooltip="הודעה זו נחשבת כתוכן שיווקי, ולכן יצורף אליה לינק להסרה מרשימת התפוצה">
                        <i class="fa-regular fa-circle-info"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="template-group">
        <div class="template-group__icon-wrapper">
            <img class="template-group__icon" src="/assets/img/Automation/icon-meeting.png" />
        </div>

        <h2 class="template-group__title">עדכון לקוחות על קביעה/שינוי בתורים</h2>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('creatingAppointmentReminder', 3)">
                <label class="switch-label template__switch">
                    שלח/י סמס בקביעת תור חדש
                    <input class="switch" [(ngModel)]="receivedparameters.creatingAppointmentReminder" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.creatingAppointmentReminder" isAnimated="true">
                <div class="template__editor">
                    <h3 class="editor__title">נוסח ההודעה</h3>

                    <div class="editor__area">
                        <div class="editor__buttons">
                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="openEditor('bodyCreatingAppointmentReminder', 3)"
                            >
                                עריכה
                                <i class="fa-regular fa-pen-line"></i>
                            </button>

                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="previewText('bodyCreatingAppointmentReminder')"
                            >
                                תצוגה
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </div>

                        <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea template__textarea">
                            <textarea
                                class="input custom-scrollbar"
                                [(ngModel)]="receivedparameters.bodyCreatingAppointmentReminder"
                                placeholder="הוסף הערות..."
                                readonly
                                disabled
                            ></textarea>

                            <span class="input-details">
                                {{ receivedparameters.bodyCreatingAppointmentReminder?.length }} תווים
                                <span *ngIf="getSMSCount('bodyCreatingAppointmentReminder') > 1">
                                    , ישלח כהודעה אחת בעלות {{ getSMSCount("bodyCreatingAppointmentReminder") }} סמסים
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('cancelingAppointmentReminder', 4)">
                <label class="switch-label template__switch">
                    שלח/י סמס בביטול תור קיים
                    <input class="switch" [(ngModel)]="receivedparameters.cancelingAppointmentReminder" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.cancelingAppointmentReminder" isAnimated="true">
                <div class="template__editor">
                    <h3 class="editor__title">נוסח ההודעה</h3>

                    <div class="editor__area">
                        <div class="editor__buttons">
                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="openEditor('bodyCancelingAppointmentReminder', 4)"
                            >
                                עריכה
                                <i class="fa-regular fa-pen-line"></i>
                            </button>

                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="previewText('bodyCancelingAppointmentReminder')"
                            >
                                תצוגה
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </div>

                        <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea template__textarea">
                            <textarea
                                class="input custom-scrollbar"
                                [(ngModel)]="receivedparameters.bodyCancelingAppointmentReminder"
                                placeholder="הוסף הערות..."
                                readonly
                                disabled
                            ></textarea>

                            <span class="input-details">
                                {{ receivedparameters.bodyCancelingAppointmentReminder?.length }} תווים
                                <span *ngIf="getSMSCount('bodyCancelingAppointmentReminder') > 1">
                                    , ישלח כהודעה אחת בעלות {{ getSMSCount("bodyCancelingAppointmentReminder") }} סמסים
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('changingDateAppointmentReminder', 5)">
                <label class="switch-label template__switch">
                    שלח/י סמס בשינוי תאריך התור
                    <input class="switch" [(ngModel)]="receivedparameters.changingDateAppointmentReminder" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.changingDateAppointmentReminder" isAnimated="true">
                <div class="template__editor">
                    <h3 class="editor__title">נוסח ההודעה</h3>

                    <div class="editor__area">
                        <div class="editor__buttons">
                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="openEditor('bodyChangingDateAppointmentReminder', 5)"
                            >
                                עריכה
                                <i class="fa-regular fa-pen-line"></i>
                            </button>

                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="previewText('bodyChangingDateAppointmentReminder')"
                            >
                                תצוגה
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </div>

                        <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea template__textarea">
                            <textarea
                                class="input custom-scrollbar"
                                [(ngModel)]="receivedparameters.bodyChangingDateAppointmentReminder"
                                placeholder="הוסף הערות..."
                                readonly
                                disabled
                            ></textarea>

                            <span class="input-details">
                                {{ receivedparameters.bodyChangingDateAppointmentReminder?.length }} תווים
                                <span *ngIf="getSMSCount('bodyChangingDateAppointmentReminder') > 1">
                                    , ישלח כהודעה אחת בעלות {{ getSMSCount("bodyChangingDateAppointmentReminder") }} סמסים
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('changingTimeAppointmentReminder', 6)">
                <label class="switch-label template__switch">
                    שלח/י סמס בשינוי שעת התור
                    <input class="switch" [(ngModel)]="receivedparameters.changingTimeAppointmentReminder" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.changingTimeAppointmentReminder" isAnimated="true">
                <!-- <div class="input-wrapper input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select template__select">
                    <span class="input-label">סוג השליחה</span>
                    <select class="input" [(ngModel)]="receivedparameters.birthdayPeriodic" (change)="onBirthdayPeriodicChange()">
                        <option *ngFor="let option of meetingMethodData" [value]="option.id">{{ option.name }}</option>
                    </select>
                </div> -->

                <div class="template__editor">
                    <h3 class="editor__title">נוסח ההודעה</h3>

                    <div class="editor__area">
                        <div class="editor__buttons">
                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="openEditor('bodyChangingTimeAppointmentReminder', 6)"
                            >
                                עריכה
                                <i class="fa-regular fa-pen-line"></i>
                            </button>

                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="previewText('bodyChangingTimeAppointmentReminder')"
                            >
                                תצוגה
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </div>

                        <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea template__textarea">
                            <textarea
                                class="input custom-scrollbar"
                                [(ngModel)]="receivedparameters.bodyChangingTimeAppointmentReminder"
                                placeholder="הוסף הערות..."
                                readonly
                                disabled
                            ></textarea>

                            <span class="input-details">
                                {{ receivedparameters.bodyChangingTimeAppointmentReminder?.length }} תווים
                                <span *ngIf="getSMSCount('bodyChangingTimeAppointmentReminder') > 1">
                                    , ישלח כהודעה אחת בעלות {{ getSMSCount("bodyChangingTimeAppointmentReminder") }} סמסים
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="template-group">
        <div class="template-group__icon-wrapper">
            <img class="template-group__icon" src="/assets/img/Automation/icon-recommend.png" />
        </div>

        <h2 class="template-group__title">תודה על ההמלצה</h2>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('thankByRecommendationReminder', 7)">
                <label class="switch-label template__switch">
                    שלח SMS תודה על ההמלצה
                    <input class="switch" [(ngModel)]="receivedparameters.thankByRecommendationReminder" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.thankByRecommendationReminder" isAnimated="true">
                <div class="template__editor">
                    <h3 class="editor__title">נוסח ההודעה</h3>

                    <div class="editor__area">
                        <div class="editor__buttons">
                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="openEditor('bodyThankByRecommendationReminder', 7)"
                            >
                                עריכה
                                <i class="fa-regular fa-pen-line"></i>
                            </button>

                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="previewText('bodyThankByRecommendationReminder')"
                            >
                                תצוגה
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </div>

                        <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea template__textarea">
                            <textarea
                                class="input custom-scrollbar"
                                [(ngModel)]="receivedparameters.bodyThankByRecommendationReminder"
                                placeholder="הוסף הערות..."
                                readonly
                                disabled
                            ></textarea>

                            <span class="input-details">
                                {{ receivedparameters.bodyThankByRecommendationReminder?.length }} תווים
                                <span *ngIf="getSMSCount('bodyThankByRecommendationReminder') > 1">
                                    , ישלח כהודעה אחת בעלות {{ getSMSCount("bodyThankByRecommendationReminder") }} סמסים
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="template__note">
                    <span class="note__text">על פי דואר זבל קישור להסרת שיווק נמוך יצורף ל- SMS</span>
                    <span class="template__tooltip" tooltip="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
                        <i class="fa-regular fa-circle-info"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="template-group">
        <div class="template-group__icon-wrapper">
            <img class="template-group__icon" src="/assets/img/Automation/icon-visit.png" />
        </div>

        <h2 class="template-group__title">תודה על הביקור</h2>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('thankByMeetingReminder', 8)">
                <label class="switch-label template__switch">
                    שלח תודה ל- SMS על ביקורך בלקוחות החדשים בלבד
                    <input class="switch" [(ngModel)]="receivedparameters.thankByMeetingReminder" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.thankByMeetingReminder" isAnimated="true">
                <div class="input-wrapper input-wrapper_with-label input-wrapper_type_range template__range">
                    <span class="input-label">שלח SMS תוך {{ receivedparameters.minutesAfterPay }} דקות לאחר התשלום:</span>
                    <div class="range">
                        <button class="range__button range__button_plus" (click)="timeValueIncrement('minutesAfterPay', 60, 5)">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                        <input
                            class="input"
                            [(ngModel)]="receivedparameters.minutesAfterPay"
                            (focus)="onRangeFocus($event.target)"
                            (input)="onRangeChange('minutesAfterPay', $event.target, 5, 60)"
                        />
                        <button class="range__button range__button_minus" (click)="timeValueDecrement('minutesAfterPay', 5, 5)">
                            <i class="fa-regular fa-minus"></i>
                        </button>
                    </div>
                </div>

                <div class="template__editor">
                    <h3 class="editor__title">נוסח ההודעה</h3>

                    <div class="editor__area">
                        <div class="editor__buttons">
                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="openEditor('bodyThankByMeetingReminder', 8)"
                            >
                                עריכה
                                <i class="fa-regular fa-pen-line"></i>
                            </button>

                            <button
                                class="button button_with-icon button_size_small button_theme_main-line editor__button"
                                (click)="previewText('bodyThankByMeetingReminder')"
                            >
                                תצוגה
                                <i class="fa-regular fa-eye"></i>
                            </button>
                        </div>

                        <div class="input-wrapper input-wrapper_with-details input-wrapper_type_textarea template__textarea">
                            <textarea
                                class="input custom-scrollbar"
                                [(ngModel)]="receivedparameters.bodyThankByMeetingReminder"
                                placeholder="הוסף הערות..."
                                readonly
                                disabled
                            ></textarea>

                            <span class="input-details">
                                {{ receivedparameters.bodyThankByMeetingReminder?.length }} תווים
                                <span *ngIf="getSMSCount('bodyThankByMeetingReminder') > 1">
                                    , ישלח כהודעה אחת בעלות {{ getSMSCount("bodyThankByMeetingReminder") }} סמסים
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="template__note">
                    <span class="note__text">על פי דואר זבל קישור להסרת שיווק נמוך יצורף ל- SMS</span>
                    <span class="template__tooltip" tooltip="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
                        <i class="fa-regular fa-circle-info"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>

    <div class="template-group">
        <div class="template-group__icon-wrapper">
            <img class="template-group__icon" src="/assets/img/Automation/icon-end.png" />
        </div>

        <h2 class="template-group__title">סוף יום</h2>

        <div class="template__card card">
            <div class="template__header" (click)="handleChange('automaticClosingCash', 9)">
                <label class="switch-label template__switch">
                    סגרו אוטומטית את הקופה
                    <input class="switch" [(ngModel)]="receivedparameters.automaticClosingCash" type="checkbox" />
                    <span class="custom-switch"></span>
                </label>
            </div>

            <div class="template__body" [collapse]="!receivedparameters.automaticClosingCash" [isAnimated]="true">
                <div class="template__text">אם אתה או הצוות שלך שוכחים לסגור את הקופה בסוף היום אפשרות זו תסגור אותה אוטומטית עבורך בשעה 23:45</div>

                <div class="template__header template__inner" (click)="handleChange('sendReportCash', 10)">
                    <label class="switch-label template__switch">
                        :שלח/י דוח קופה לטלפונים הבאים
                        <input class="switch" [(ngModel)]="receivedparameters.sendReportCash" type="checkbox" />
                        <span class="custom-switch"></span>
                    </label>
                </div>

                <div class="template__body template__inner template__inputs" [collapse]="!receivedparameters.sendReportCash" [isAnimated]="true">
                    <div class="template__input">
                        <div class="input-wrapper" [ngClass]="{ 'input-wrapper_error': !isFirstInputValid }">
                            <input
                                #firstInput
                                class="input"
                                [(ngModel)]="receivedparameters.phone1SendReportCash"
                                type="tel"
                                inputmode="tel"
                                maxlength="10"
                                pattern="05[0-9]{8}"
                                [disabled]="!isEditingFirstInput"
                                placeholder="הכנס מספר טלפון"
                                autocomplete="off"
                            />
                        </div>

                        <button
                            *ngIf="!isEditingFirstInput"
                            class="button button_with-icon button_size_small button_theme_main-line input__button input__button_size_large"
                            (click)="toggleInput(1)"
                            [disabled]="isEditingSecondInput"
                        >
                            עריכה
                            <i class="fa-regular fa-pen-line"></i>
                        </button>

                        <button
                            *ngIf="isEditingFirstInput"
                            class="button button_with-icon button_size_small button_theme_main input__button"
                            (click)="saveInput(1)"
                        >
                            אישור
                            <i class="fa-regular fa-check"></i>
                        </button>

                        <button
                            *ngIf="isEditingFirstInput"
                            class="button button_with-icon button_size_small button_theme_main-line input__button"
                            (click)="cancelInput(1)"
                        >
                            ביטול
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                    </div>

                    <div class="template__input">
                        <div class="input-wrapper" [ngClass]="{ 'input-wrapper_error': !isSecondInputValid }">
                            <input
                                #secondInput
                                class="input"
                                [(ngModel)]="receivedparameters.phone2SendReportCash"
                                type="tel"
                                inputmode="tel"
                                maxlength="10"
                                pattern="05[0-9]{8}"
                                [disabled]="!isEditingSecondInput"
                                placeholder="הכנס מספר טלפון"
                                autocomplete="off"
                            />
                        </div>

                        <button
                            *ngIf="!isEditingSecondInput"
                            class="button button_with-icon button_size_small button_theme_main-line input__button input__button_size_large"
                            (click)="toggleInput(2)"
                            [disabled]="isEditingFirstInput"
                        >
                            עריכה
                            <i class="fa-regular fa-pen-line"></i>
                        </button>

                        <button
                            *ngIf="isEditingSecondInput"
                            class="button button_with-icon button_size_small button_theme_main input__button"
                            (click)="saveInput(2)"
                        >
                            אישור
                            <i class="fa-regular fa-check"></i>
                        </button>

                        <button
                            *ngIf="isEditingSecondInput"
                            class="button button_with-icon button_size_small button_theme_main-line input__button"
                            (click)="cancelInput(2)"
                        >
                            ביטול
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog
    [ngClass]="{ 'custom-dialog': isDialogVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isDialogVisible"
    [header]="dialogTitle"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="modal__text">{{ dialogMessage }}</div>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_main-line" (click)="closeDialog()">הבנתי, סגור</button>
    </div>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isPreviewDialogVisible }"
    styleClass="modal modal_purpose_sms-preview"
    [(visible)]="isPreviewDialogVisible"
    header="הודעה לדוגמה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <div class="message-modal__body">
        <div class="message-modal__phone">
            <div class="phone__header">
                <span class="phone__arrow-down">
                    <i class="fa-regular fa-angle-down"></i>
                </span>
                <span class="phone__number">0546678912</span>
                <img class="phone__client-image" src="/assets/img/Automation/ic_avatar.svg" />
                <span class="phone__arrow-right">
                    <i class="fa-regular fa-angle-right"></i>
                </span>
            </div>

            <div class="phone__body">
                <div class="phone__message">
                    <span class="phone__message-text">{{ dialogMessage }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="message-modal__footer">
        <button class="button button_theme_main-line" (click)="closePreviewModal()">סגור</button>
    </div>
</p-dialog>

<div
    appHostListenerBeforeUnload
    (componentHasChangedOutput)="this.componentHasChanged = $event"
    [saveData]="saveData"
    [receivedData]="receivedparameters"
></div>
